import type { PublicationCardItemWithVideo } from '@news-mono/web-common'
import type { VideoMetaDTO } from '@west-australian-newspapers/publication-types'

export function patchVerticalImageCrops(
    baseItem: PublicationCardItemWithVideo,
    video: VideoMetaDTO,
): PublicationCardItemWithVideo {
    const poster = video.posterImage
    if (!poster) return baseItem

    const existingImage = baseItem.image
    const existingCrops = existingImage?.crops

    // If the image or its crops are missing, remove the image so the component uses a fallback
    if (!existingImage || !existingCrops) {
        return {
            ...baseItem,
            image: undefined,
        }
    }

    const original = existingCrops.original
    const originalInvalid =
        !original ||
        !original.reference ||
        original.reference.trim().length === 0 ||
        original.width === 0 ||
        original.height === 0

    // If the existing original crop is unusable, remove the image to activate fallback behaviour
    if (originalInvalid) {
        return {
            ...baseItem,
            image: undefined,
        }
    }

    const crops = { ...existingCrops }
    const nine = crops['9:16']
    const nineMissing =
        !nine || !nine.reference || nine.reference.trim().length === 0

    // Only generate a 9:16 crop when it is missing or has an invalid reference
    if (nineMissing) {
        const { width, reference } = poster
        crops['9:16'] = {
            reference,
            width,
            height: Math.round((width * 16) / 9),
            ratio: { width: 9, height: 16 },
        }
    }

    return {
        ...baseItem,
        image: {
            ...existingImage,
            userSelectedCrop: '9:16',
            crops,
        },
    }
}
